import { SvgProps } from "components/icons/types";

export const OctagonExclamation = (props: SvgProps) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.4872 3.58808L10.4119 0.512167C10.0812 0.182 9.64133 0 9.17467 0H4.82592C4.35925 0 3.91942 0.182 3.58808 0.51275L0.51275 3.58808C0.182583 3.91883 0 4.35808 0 4.82533V9.17467C0 9.64192 0.182 10.0812 0.51275 10.4119L3.58808 13.4878C3.91883 13.818 4.35867 14 4.82533 14H9.17408C9.64075 14 10.0806 13.818 10.4119 13.4872L13.4867 10.4119C13.8168 10.0812 13.9994 9.64192 13.9994 9.17467V4.82533C13.9994 4.35808 13.8174 3.91883 13.4872 3.58808ZM12.8333 9.17467C12.8333 9.32808 12.7715 9.47858 12.6624 9.58708L9.58767 12.6618C9.47683 12.7721 9.32983 12.8333 9.17408 12.8333H4.82533C4.66958 12.8333 4.52258 12.7727 4.41233 12.6624L1.33758 9.58708C1.2285 9.478 1.16667 9.32808 1.16667 9.17467V4.82533C1.16667 4.67192 1.2285 4.52142 1.33758 4.41292L4.41175 1.33817C4.52258 1.22792 4.66958 1.16667 4.82533 1.16667H9.17408C9.32983 1.16667 9.47683 1.22733 9.58708 1.33758L12.6618 4.41292C12.7709 4.522 12.8327 4.67192 12.8327 4.82533L12.8333 9.17467ZM7.58333 7.58333H6.41667V3.5H7.58333V7.58333ZM7.875 9.625C7.875 10.108 7.483 10.5 7 10.5C6.517 10.5 6.125 10.108 6.125 9.625C6.125 9.142 6.517 8.75 7 8.75C7.483 8.75 7.875 9.142 7.875 9.625Z"
      fill="currentColor"
    />
  </svg>
);
